import { scaleSequential } from 'd3-scale';
import { interpolateViridis, interpolateRdYlGn } from 'd3-scale-chromatic';

export const ATTRIBUTE_OPTIONS = {
  wli: {
    label: 'Water Level Index',
    rangeTitle: 'WLI',
    rangeValues: ['-100', '+100'],
    rangeLabels: ['Dry', 'Wet'],
    colorMapInterpolator: scaleSequential(interpolateViridis).domain([1, 0])
  },
  gaugeCount: {
    label: 'Data Scarcity',
    rangeTitle: 'Gauge Concentration',
    rangeValues: ['', ''],
    rangeLabels: ['Few', 'Many'],
    colorMapInterpolator: interpolateRdYlGn
  }
};

export const calculateHaversineDistance = (lat1, lng1, lat2, lng2) => {
  function toRad(x) {
    return (x * Math.PI) / 180;
  }

  const R = 6371; // Radius of the Earth in km
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
      + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2))
      * Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in km
};

export const formatDateString = (dateString) => {
  if (!dateString) return '';
  const parts = dateString.split('-');
  const date = new Date(parts[0], parts[1] - 1, parts[2]);
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return date.toLocaleDateString('en-US', options);
};

export const API_GATEWAY_URL = 'https://f0nfrr51sk.execute-api.us-west-2.amazonaws.com';

export const NEARBY_GAUGES_RADIUS = 30;

export const IS_IPAD = navigator.maxTouchPoints && navigator.maxTouchPoints > 2;

export const H3_HEXAGON_RES = 3;

export const IS_PRODUCTION = process.env.NODE_ENV !== 'development';
